var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2693 20.1923V10.5769",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.1924V4.80774",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73071 20.1923V14.4231",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96143 25.0385H23.0383V23.0385H1.96143V25.0385ZM25.0383 23.0385V1.96155H23.0383V23.0385H25.0383ZM23.0383 -0.0384521H1.96143V1.96155H23.0383V-0.0384521ZM1.96143 23.0385V1.96155H-0.0385742V23.0385H1.96143ZM25.0383 1.96155C25.0383 0.856979 24.1429 -0.0384521 23.0383 -0.0384521V1.96155V1.96155H25.0383ZM23.0383 25.0385C24.1429 25.0385 25.0383 24.143 25.0383 23.0385H23.0383V25.0385ZM1.96143 23.0385H-0.0385742C-0.0385742 24.143 0.856856 25.0385 1.96143 25.0385V23.0385ZM1.96143 -0.0384521C0.856857 -0.0384521 -0.0385742 0.856979 -0.0385742 1.96155H1.96143L1.96143 1.96155V-0.0384521Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardChart);
export default __webpack_public_path__ + "static/media/card-chart.83deb06d526946d781346c4bbe613a46.svg";
export { ForwardRef as ReactComponent };